import { render, staticRenderFns } from "./TheModalHelp.vue?vue&type=template&id=448db66e&"
import script from "./TheModalHelp.vue?vue&type=script&lang=js&"
export * from "./TheModalHelp.vue?vue&type=script&lang=js&"
import style0 from "./TheModalHelp.vue?vue&type=style&index=0&id=448db66e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports